import { AxiosError } from "axios";

import type { ErrorHandler } from "./errorHandler.types";
import { parseBackendError } from "@shared/api/utils/parseBackendError";
import "@shared/api/types/error.types";

interface BackendErrorData {
  message?: string;
}

export const backendErrorParserHandler: ErrorHandler = (
  error: AxiosError,
) => {
  const data = error.response?.data as BackendErrorData | undefined;
  const message = data?.message;

  if (typeof message !== "string") return false;

  const parsed = parseBackendError(message);
  if (!parsed) return false;

  console.error(
    `[Backend error] ${parsed.code} ${parsed.originalMessage}`,
  );

  // `parsedMessage` precisa carregar o código `X.Y.Z` para o usuário
  // conseguir citá-lo ao abrir um chamado de suporte. Ver `i18n.mdc` §5
  // ("código sempre visível ao usuário") e `error-mapping.mdc`
  // ("Mensagem + código são públicos; apenas Descrição é interna").
  error.parsedMessage = parsed.formattedMessage;
  error.parsedError = parsed;

  return false;
};
